import { connect } from "react-redux";
// 定制订单编辑页
import CustomOrder from "../components/CustomOrder";

const mapState = state => ({
  skuList: state.customOrder.skuList,
  orderList: state.customOrder.orderList,
  editOrderId: state.customOrder.editOrderId,
  customerFile: state.customOrder.customerFile,
  customData: state.customOrder.customData,
  money: state.customOrder.money
});

const mapDispatch = dispatch => {
  const oi = dispatch.customOrder;
  return {
    getSkuList: oi.getSkuList,
    addOrUpdateOrder: oi.addOrUpdateOrder,
    delTableRow: oi.delOrderAndUpdateOrderList,
    editTableRow: oi.editOrderAndUpdateOrderList,
    cancelEditForm: oi.cancelEditForm,
    uploadFile: dispatch.uploadMg.uploadFile,
    addUploadFile: oi.addUploadFile,
    toSaveMode: oi.toSaveMode,
    resetCustomOrder: oi.resetCustomOrder,
    getMoney:oi.getMoney,
  };
};

export default connect(
  mapState,
  mapDispatch
)(CustomOrder);
